import React from 'react'
import styles from '../Header.module.scss'

import { Dropdown, Avatar, Tag } from 'antd'
import IconProfile from 'assets/icons/icon-profile.svg'
import iconLogOut from 'assets/icons/icon-log-out.svg'
import IconDropdownBlack from 'assets/icons/icon-dropdown-black.svg'
import MenuDropdown from 'components/Menu/MenuDropdown'
import KidProfile from 'assets/images/profile/profile-picture-04.svg'

import { USER_ROLE } from 'util/config'
import ListDropdown from 'components/List/ListDropdown'
import { TranslateLanguage } from 'util/Translate'
import { vocabSchoolCollabUserRightNav } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vocabSchoolCollabUserRightNav)

export default function SchoolCollabUserRightNav(props) {
  const { user } = props

  return (
    <div className={styles.headerProfile} >
      <div className={styles.subProfile} >
        <span style={{ display: 'flex', cursor: 'pointer' }} onClick={() => {
          props.props.history.push('/profile')
        }}>
          <div className={styles.nameAndSchool} >
            <div className={styles.divDisplayName}>
              <span className={styles.displayName}>{user.displayName || 'Guest'}</span>
            </div>
            <div className={styles.divGrade}>
              <span className={styles.grade} >{user.role === USER_ROLE.TEACHER ? `${translate.convert('โรงเรียน')}${user.schoolCollabName}` : `ID: ${user.studentId}`}</span>
            </div>
          </div>

          <div>
            <Avatar src={user.imageProfile || KidProfile} />
          </div>
          {
            user.mySubscription.length > 0 && <div className={styles.tagStyle} >
              <Tag color='success'>School</Tag>
            </div>
          }

        </span>
        <div className={styles.divDropdown}>
          <Dropdown overlay={MenuDropdown([
            { label: <ListDropdown text={translate.convert('ข้อมูลผู้ใช้งาน')} icon={IconProfile} action={props.onProfile} /> },
            { label: <ListDropdown text={translate.convert('ออกจากระบบ')} icon={iconLogOut} action={props.onSignOut} /> }
          ])}
            trigger={['click']} placement='bottomRight' arrow>
            <div style={{ cursor: 'pointer' }}>
              <Avatar alt='dropdownprofile' src={IconDropdownBlack} />
            </div>
          </Dropdown>
        </div>

      </div>

    </div>
  )
}